import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { EmptyOrderPosIcon } from "../../../../assets/icons.constants";
import { useSearchParams } from "../../../../hooks";
import "./EmptyOrder.scss";

const EmptyOrder = (props) => {
  const { t } = useTranslation();
  const { handleAddItem } = props;
  const { buttonTitle = t("posCart.createOrdered", "Create order"), isDisabled } = props;
  const history = useHistory();
  const query = useSearchParams();
  return (
    <div className="empty-order">
      <div className="empty-order-icon">
        <EmptyOrderPosIcon />
      </div>
      <div className="empty-order-text">{t("posCart.addItemOfEmptyOrder", "There is no item yet. Let's order!")}</div>
      {isDisabled ? (
        <div className="empty-order-btn empty-order-btn-disabled">{buttonTitle}</div>
      ) : (
        <div className="empty-order-btn" onClick={() => handleAddItem(query)}>
          {buttonTitle}
        </div>
      )}
    </div>
  );
};

export default EmptyOrder;
